"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppInfo = void 0;
var getConfigValue_1 = require("./getConfigValue");
var DEFAULT_LOG_BASE_URL = 'https://www.cian.ru/ajax/log-error/';
var AppInfo = /** @class */ (function () {
    function AppInfo(application) {
        this.application = application || 'unknown';
        this.init();
    }
    AppInfo.prototype.init = function () {
        var _this = this;
        this.refresh();
        document.addEventListener('DOMContentLoaded', function () {
            _this.refresh();
        });
    };
    AppInfo.prototype.refresh = function () {
        this.mcsRunEnv = this.ensureMcsRunEnv();
        this.mcsRunEnvType = this.ensureMcsRunEnvType();
        this.version = this.ensureVersion();
    };
    Object.defineProperty(AppInfo.prototype, "href", {
        get: function () {
            return window.location.href;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppInfo.prototype, "screenSize", {
        get: function () {
            var _a = window.screen, width = _a.width, height = _a.height;
            return "".concat(width, "/").concat(height);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppInfo.prototype, "availableScreenSize", {
        get: function () {
            var _a = window.screen, availWidth = _a.availWidth, availHeight = _a.availHeight;
            return "".concat(availWidth, "/").concat(availHeight);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AppInfo.prototype, "logBaseUrl", {
        get: function () {
            var _a, _b;
            /**
             * Данный fallback необходим, так как есть сервисы, которые не используют @cian/web,
             * а разработчик может забыть установить переменную
             */
            if (!window._cianSystemLogger) {
                return DEFAULT_LOG_BASE_URL;
            }
            return (((_a = window._cianSystemLogger[this.application]) === null || _a === void 0 ? void 0 : _a.logBaseUrl) ||
                ((_b = window._cianSystemLogger.v2) === null || _b === void 0 ? void 0 : _b.logBaseUrl) ||
                DEFAULT_LOG_BASE_URL);
        },
        enumerable: false,
        configurable: true
    });
    AppInfo.prototype.ensureMcsRunEnv = function () {
        return (0, getConfigValue_1.getConfigValue)(this.application, 'mcsRunEnv') || 'unknown';
    };
    AppInfo.prototype.ensureMcsRunEnvType = function () {
        return (0, getConfigValue_1.getConfigValue)(this.application, 'mcsRunEnvType') || 'unknown';
    };
    AppInfo.prototype.ensureVersion = function () {
        return (0, getConfigValue_1.getConfigValue)(this.application, 'version') || 'unknown';
    };
    return AppInfo;
}());
exports.AppInfo = AppInfo;
//# sourceMappingURL=AppInfo.js.map